import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/newsletter/page.tsx");
